export function formatCurrency(value: number, fractionDigits = 0) {
    return value.toLocaleString("de-DE", {
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits,
    });
}
